<template>
  <div id="app" :class="{loading : loadingStatus}">
    <svg xmlns="http://www.w3.org/2000/svg" id="loadingIndicator" viewBox="0 0 545.4 314" width="70px" height="70px">
        <path d="M88,291.4H37.2V135.6c25.4,11.7,50.8,0,50.8,0Z" style="fill:#3c3c3b"/>
        <path d="M152.8,88.1,135.4,88c10.5-25.8-.2-50.7-.2-50.7H412.6L339.36,88H203.6V291.4H152.8Z" style="fill:#3c3c3b"/>
        <path class="loading-path" d="M268.6,206.8l-.2-84.7h.2q0-84.75,84.7-84.7H438q84.75,0,84.7,84.7v84.7q0,84.75-84.7,84.7H353.3Q268.85,291.5,268.6,206.8Zm50.8-8.5c0,28.2,14.1,42.4,42.4,42.4h67.8c28.2,0,42.4-14.1,42.4-42.4V122.1q0-33.9-42.4-33.9H361.8c-28.2,0-42.4,14.1-42.4,42.4Z" style="fill:#3c3c3b"/>
        <circle cx="62.3" cy="62.3" r="62.3" style="fill:#e30613"/>
    </svg>
    <MainHeader :currentRoute="currentRouteName" />
    <transition name="slide-fade" mode="out-in">
      <router-view />
    </transition>
    <MainFooter v-if="!loadingStatus" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
const MainHeader = () => import('@/components/Main/Header.vue')
const MainFooter = () => import('@/components/Main/Footer.vue')

export default {
  name: 'App',
  metaInfo () {
    return {
      title: 'ito consult GmbH - IT Spezialisten aus Dresden',
      meta: [
        { name: 'description', content: 'ito consult GmbH - IT Know-How seit mehr als 25 Jahren! Zuhause in Dresden - Jetzt Projekte realisieren' },
        { property: 'og:title', content: 'ito consult GmbH - IT Know-How seit mehr als 25 Jahren!' },
        { property: 'og:description', content: '25 Jahre geballtes IT-Wissen. Das ist ito consult GmbH aus Dresden ' },
        { name: 'robots', content: 'index,follow' }
      ]
    }
  },
  computed: {
    currentRouteName () {
      return this.$route.name
    },
    loadingStatus () {
      return this.$store.getters.loadingStatus
    },
    noScollBodyStatus () {
      return this.$store.getters.noScollBodyStatus
    },
    ...mapGetters(['content'])
  },
  data: function () {
    return {}
  },
  beforeMount () {
    this.getContent()
    this.getMeta()
  },
  methods: {
    ...mapActions(['getContent', 'getMeta']),
    getMetaTitle (t) {
      if (typeof this.$store.getters.meta.data !== 'undefined') {
        const txt = this.$store.getters.meta.data.filter(item => {
          return item.route.indexOf(t) > -1
        })
        return txt.length ? txt[0].meta_title : ''
      } else {
        return ''
      }
    },
    getOGTitle (t) {
      if (typeof this.$store.getters.meta.data !== 'undefined') {
        const txt = this.$store.getters.meta.data.filter(item => {
          return item.route.indexOf(t) > -1
        })
        return txt.length ? txt[0].og_title : ''
      } else {
        return ''
      }
    },
    getDescription (t) {
      if (typeof this.$store.getters.meta.data !== 'undefined') {
        const txt = this.$store.getters.meta.data.filter(item => {
          return item.route.indexOf(t) > -1
        })
        return txt.length ? txt[0].meta_description : ''
      } else {
        return ''
      }
    },
    getOGDescription (t) {
      if (typeof this.$store.getters.meta.data !== 'undefined') {
        const txt = this.$store.getters.meta.data.filter(item => {
          return item.route.indexOf(t) > -1
        })
        return txt.length ? txt[0].og_description : ''
      } else {
        return ''
      }
    }
  },
  components: {
    MainHeader,
    MainFooter
  },
  watch: {
    noScollBodyStatus: function () {
      this.noScollBodyStatus ? document.getElementsByTagName('body')[0].classList.add('no-scroll') : document.getElementsByTagName('body')[0].classList.remove('no-scroll')
    }
  }
}
</script>

<style>
html,body {background: #fff;}
body {color: #555;-webkit-font-smoothing: antialiased;-moz-osx-font-smoothing: grayscale; font-family: 'Quicksand', sans-serif;}
body.no-scroll {overflow: hidden !important;}
body::before {
    transition: opacity 1000ms, z-index 0ms 1001ms;
    content: "";
    display: block;
    z-index: -1;
    top: 0; left: 0; bottom: 0; right: 0;
    position: fixed;
    background: #fff;
    opacity: 0;
}

/* FONTS */
/* cyrillic-ext */
@font-face {
  font-family: 'Merriweather';
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src: url(~@/assets/fonts/u-4m0qyriQwlOrhSvowK_l5-eRZDf-LVrPHpBXw.woff2) format('woff2');
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
}
/* cyrillic */
@font-face {
  font-family: 'Merriweather';
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src: url(~@/assets/fonts/u-4m0qyriQwlOrhSvowK_l5-eRZKf-LVrPHpBXw.woff2) format('woff2');
  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
/* vietnamese */
@font-face {
  font-family: 'Merriweather';
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src: url(~@/assets/fonts/u-4m0qyriQwlOrhSvowK_l5-eRZBf-LVrPHpBXw.woff2) format('woff2');
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: 'Merriweather';
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src: url(~@/assets/fonts/u-4m0qyriQwlOrhSvowK_l5-eRZAf-LVrPHpBXw.woff2) format('woff2');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Merriweather';
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src: url(~@/assets/fonts/u-4m0qyriQwlOrhSvowK_l5-eRZOf-LVrPHp.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* vietnamese */
@font-face {
  font-family: 'Quicksand';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(~@/assets/fonts/6xKtdSZaM9iE8KbpRA_hJFQNYuDyP7bh.woff2) format('woff2');
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: 'Quicksand';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(~@/assets/fonts/6xKtdSZaM9iE8KbpRA_hJVQNYuDyP7bh.woff2) format('woff2');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Quicksand';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(~@/assets/fonts/6xKtdSZaM9iE8KbpRA_hK1QNYuDyPw.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* vietnamese */
@font-face {
  font-family: 'Quicksand';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url(~@/assets/fonts/6xKtdSZaM9iE8KbpRA_hJFQNYuDyP7bh.woff2) format('woff2');
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: 'Quicksand';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url(~@/assets/fonts/6xKtdSZaM9iE8KbpRA_hJVQNYuDyP7bh.woff2) format('woff2');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Quicksand';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url(~@/assets/fonts/6xKtdSZaM9iE8KbpRA_hK1QNYuDyPw.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

#loadingIndicator {
    position: fixed;
    top: calc(50% - 35px);
    left: calc(50% - 35px);
    z-index: -1;
    opacity: 0;
}
.loading-path {animation: rotateIto 2s ease infinite; transform-origin: center; transform-box: fill-box;}
@keyframes rotateIto {to {transform: rotate(360deg);}}
#app.loading::before {
    opacity: 1;
    z-index: 1000;
}
#app.loading #loadingIndicator {
    opacity: 1;
    z-index: 1001;
}
:root {
    --ito-red: #cc071e;
}
.no-style {margin: 0; padding: 0; list-style: none;}
/* Navigation for mobile */
.navigation-main {
    position: fixed;
    left: 0;
    bottom: 0;
    top: 0;
    background: #fff;
    transform: translateX(-100%);
    transition: transform 500ms, box-shadow 1s;
}
.navigation-main.is_active {
    z-index: 100;
    box-shadow: 0 0px 30px rgba(0,0,0,.1), 0 0 0 100vw rgba(0,0,0,.1);
    transform: translateX(0);
}
@media (min-width: 992px){
    .navigation-main {
        background: none;
        position: relative;
        left: initial;
        top: initial;
        bottom: initial;
        box-shadow: none !important;
        transition: none !important;
        transform: none;
    }
    ul.sub {position: absolute; opacity: 0; transform: translateY(1rem); transition: opacity 300ms, transform 300ms;}

    header.main nav ul li {overflow: hidden;}
    header.main nav ul li:hover {overflow: visible;}
    header.main nav ul li:hover  ul.sub {
        display: block;
        background: rgba(255,255,255,1);
        opacity: 1;
        transform: translateY(0);
        box-shadow: 0 30px 30px -30px rgba(0,0,0,.1);

    }
}
header.main .logo svg {transition: height 400ms;}
header.main {padding: 1.5rem 0; transition: box-shadow 400ms, padding 400ms, transform 200ms; position: fixed; top: 0; width: 100vw; z-index: 999;}
header.main.nav-down {box-shadow: 0 0px 30px rgba(0,0,0,.1); background: #fff;}
header.main.nav-small {padding: 1rem 0; background: #fff;}
header.main.nav-small .logo svg  {height: 30px;}
@media(min-width: 992px){
    header.main.nav-up {padding: 1rem 0; background: #fff; transform: translate(0,-100%);}
}
header.main nav ul li a {text-decoration: none; color: #666;
    /* text-transform: uppercase; */
    transition: all 300ms;
    font-size: 1.3em;
    font-weight: 400;
    overflow: hidden;
    position: relative;
    white-space: nowrap;
}
header.main nav ul li ul.sub li a {
    font-size: 1em;
    color: #888;
    display: block;
    white-space: nowrap;
}
@media(min-width: 992px){
    header.main nav ul li a:not(.btn)::after, header.main nav ul li a:not(.btn)::before {
        content: "";
        height: 1px;
        bottom: 1px;
        left: 1.5rem;
        right: 1.5rem;
        background: #333;
        z-index: 3;
        display: block;
        position: absolute;
        width: 0;
        transition: all 400ms;
    }
    header.main nav ul li a:not(.btn)::before {
        background: var(--ito-red);
        transition-delay: 500ms;
        z-index: 4;
        border-right: 1rem solid #fff;
        margin-left: -1rem;
    }
}
header.main nav > ul > li.current > a:not(.btn) {
    color: #333;
}
header.main nav > ul > li.current > a:not(.btn)::after {
    width: calc(100% - 3rem);
}
header.main a.router-link-active {color: var(--ito-red) !important;}
header.main nav ul li a:not(.btn):hover::after {
    background: var(--ito-red);
    width: calc(100% - 3rem);
}
header.main nav ul li a:not(.btn):hover::before {
    width: calc(100% - 3rem);
    margin-left: 1rem;
}
.main-content {margin-top: calc(3rem + 40px);}
a.animated-arrow, a.animated-arrow svg {transition: all 400ms;}
a.animated-arrow:hover {padding: .375rem 1rem;}
a.animated-arrow:hover svg {margin-right: .5rem;}
.btn-outline-ito {
    color: #444;
    border-color: #444;
    border-radius: 2rem;
}
.btn-outline-ito:hover {
    color: #fff;
    background-color: #222;
    border-color: #222;
}
.btn-outline-ito.hover-red:hover {
    background-color: var(--ito-red);
    border-color: var(--ito-red);
}
.block-content {
    position: relative;
    font-size: .8em;
}
.block-content h2 {
    font-size: 1.4em;
    font-weight: 300;
    margin-bottom: .75rem;
    font-family: 'Merriweather', serif; /*'Work Sans', sans-serif;*/
    font-style: italic;
    color: var(--ito-red);
    display: inline-block;
    position: relative;
    overflow: hidden;
}
.block-content article > h2 {display: block;}
@media(min-width: 992px){
    .block-content {
        font-size: 1em;
    }
    .block-content h2 {
        font-size: 2vw;
    }
}
@media(min-width: 1400px){
    .block-content h2 {
        font-size: 2rem;
    }
}
.block-content h2::after {
    content: "";
    background: var(--ito-red);
    width: 100%;
    height: 1px;
    position: absolute;
    left: 0;
    transform: translateX(-100%);
    bottom: 0;
    display: block;
    transition: all 800ms;
    transition-delay: 1000ms;
}
.block-content h2::before {
    content: "";
    background: #666;
    width: 100%;
    height: 1px;
    position: absolute;
    left: 0;
    bottom: 0;
    display: block;
    transform: translateX(-100%);
    transition: all 1000ms;
    transition-delay: 500ms;
    z-index: 2;
}
.block-content .aos-animate h2::after {
    transform: translateX(100%);
}
.block-content .aos-animate h2::before {
    transform: translateX(100%);
}
.block-content {font-size: 1.25em; font-weight: 400;}
.content-midwide {max-width: 992px; margin: 0 auto;}
.toggleMenu.burger {
    position: relative;
    width: 1.5rem;
    height: 1.2rem;
    display: block;
    transition: all 500ms;
}
.toggleMenu.burger:hover {color: var(--ito-red);}
.toggleMenu.burger .innerBurger {
    position: absolute;
    top: 50%;
    width: 1.5rem;
    height: 1px;
    border-radius: 2px;
    background: #222;
    transition: all 200ms;
}
.toggleMenu.burger::before {
    content: "";
    position: absolute;
    width: 1.5rem;
    height: 1px;
    top: 50%;
    border-radius: 2px;
    background: #222;
    display: block;
    transition: all 500ms;
    transform: translateY(.5rem);
}
.toggleMenu.burger::after {
    content: "";
    position: absolute;
    width: 1.5rem;
    height: 1px;
    top: 50%;
    border-radius: 3px;
    background: #222;
    display: block;
    transition: inherit;
    transform: translateY(-.5rem);
}
.toggleMenu.burger.is_active .innerBurger {
    opacity: 0;
    transform: translateX(-2rem);
}
.toggleMenu.burger.is_active::before {
    transform: rotate(135deg);
    transform-origin: center center;
    width: calc(1.5rem);
}
.toggleMenu.burger.is_active::after {
    transform:  rotate(-135deg);
    transform-origin: center center;
    width: calc(1.5rem)

}
.toggleMenu.burger:hover .innerBurger,
.toggleMenu.burger:hover::before,
.toggleMenu.burger:hover::after {
    background: var(--ito-red);
}
.bg-animation {
    display: block;
    width: 50%;
    height: 120%;
    position: absolute;
    top: -10%;
}
.bg-animation.bg-left {
    right: 65%;
}
.bg-animation.bg-right {
    left: 65%;
}
.bg-animation::after {
    content: "";
    position: absolute;
    top: 0; right: 0;
    bottom: 0;
    display: block;
    width: 100%;
    opacity: 1;
}
.bg-animation.bg-left::after {
    background: linear-gradient(90deg, rgba(255,255,255,1)0%, rgba(255,255,255,1) 70%, rgba(255,255,255,0) 100%);
}
.bg-animation.bg-right::after {
    background: linear-gradient(90deg, rgba(255,255,255,0)0%, rgba(255,255,255,1) 30%, rgba(255,255,255,1) 100%);
}
.animatedSVG {height: 100%; position: absolute; top: 0; right: 0;}
.bg-right .animatedSVG {
    left: 0;
    right: auto;
}
.img-container {border: 1px solid #fff; box-shadow: 0 0 4rem rgba(0,0,0,.1); background: #ccc}
.animatedSVG path { transform-origin: center center;}
.animatedSVG path.main {fill: #888;}
.animatedSVG path.p1 {
    opacity: .2;
    fill:url(#svggradient);
    -webkit-animation: rotating 222s linear infinite;
    -moz-animation: rotating 222s linear infinite;
    -ms-animation: rotating 222s linear infinite;
    -o-animation: rotating 222s linear infinite;
    animation: rotating 222s linear infinite;
}
.animatedSVG path.p2 {
    opacity: .7;
    fill:url(#svggradient);
    -webkit-animation: rotating 180s linear infinite;
    -moz-animation: rotating 180s linear infinite;
    -ms-animation: rotating 180s linear infinite;
    -o-animation: rotating 180s linear infinite;
    animation: rotating 180s step-end infinite;
}
.animatedSVG path.p3 {
    opacity: .5;
    fill:url(#svggradient);
    -webkit-animation: rev-rotating 150s linear infinite;
    -moz-animation: rev-rotating 150s linear infinite;
    -ms-animation: rev-rotating 150s linear infinite;
    -o-animation: rev-rotating 150s linear infinite;
    animation: rev-rotating 150s step-end infinite;
}
@-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes rotating {
    from {
      -ms-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -ms-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @-webkit-keyframes rev-rotating /* Safari and Chrome */ {
    from {
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(-360deg);
      -o-transform: rotate(-360deg);
      transform: rotate(-360deg);
    }
  }
  @keyframes rev-rotating {
    from {
      -ms-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -ms-transform: rotate(-360deg);
      -moz-transform: rotate(-360deg);
      -webkit-transform: rotate(-360deg);
      -o-transform: rotate(-360deg);
      transform: rotate(-360deg);
    }
  }

  .partner-link img {
      filter: grayscale(100);
      transition: filter 400ms;
  }
  .partner-link:hover img {
      filter: grayscale(0);
  }
  .bg-lightgrey {background: #f3f3f3;}
  .bg-lightgrey-gradient {
    background: rgb(243,243,243);
    background: linear-gradient(0deg, rgba(224,224,224,1) 0%, rgba(243,243,243,1) 100%);
  }

  .img-group .img-1, .img-group .img-2 {position: relative;}
  .img-group .img-1 {width: 55%;}
  .img-group .img-2 {width: 55%; margin-left: -10%; z-index: 2;}
  .img-group .img-container {transition: all 0;}
  .ito-card {background: #fff; box-shadow: 0 2rem 4rem rgba(0,0,0,.1); border-radius: .25rem;}
  .ito-card .card-img, .ito-card  .card-img-top {border-radius: .25rem;}
  .ito-card .card-title {color: var(--ito-red)}
  .ito-card .card-text {font-size: 1em;}
  .ito-card .card-footer { border: none; background: none; padding-top: 0 !important;}
  /* .block-skills {box-shadow: 0 1rem 3rem -1rem rgba(0,0,0,.1);} */
  .block-skills nav {box-shadow: .5rem 0 .5rem -.75rem  rgba(0,0,0,1); z-index: 3;}
  .block-skills nav .nav {display: block;}
  .block-skills nav .nav button {border: none; background: none; box-shadow: none; color: #666; font-size: 1.25rem; font-weight: 300; position: relative; text-align: left;}
  .block-skills nav .nav button:hover {color: #333;}
  .block-skills nav .nav li:not(:last-child) {border-bottom: 1px solid #ddd; box-shadow: 0 1px 0 #fff;}
  .block-skills nav .nav button.active {color: var(--ito-red) !important;}
  .block-skills nav .nav button.active::after {
      content: "";
      background: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="rgba(0,0,0,.5)" class="bi bi-arrow-right-circle" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/></svg>');
      width: 16px;
      height: 16px;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      z-index: 2;
  }
[data-bg="grey"] {
    background: #ddd;
}
blockquote {font-family: 'Merriweather',sans-serif; font-style: italic; font-size: 2em; line-height: 1.2;}
blockquote > .author {font-size: 1rem; font-style: normal; }
.main-footer {background: #f0f0f0}
.main-footer .container {font-weight: 300; font-size: 1em; color: #666;}
.main-footer a {text-decoration: none; color: #666; transition: all 300ms;}
.main-footer a:hover {color: #cc071e;}
.main-footer .socialmedia {color: #666; transition: all 300ms}
.main-footer .socialmedia.facebook:hover {color: #3b5998;}
.main-footer .socialmedia.xing:hover {color: #126567;}
.main-footer .socialmedia.instagram:hover {color: #3f729b;}
.main-footer .socialmedia.youtube:hover {color: #b2071d;}
.form-control.border-bottom-only {
    border: 1px solid rgba(0,0,0,0);
    border-radius: 0;
    border-bottom: 1px solid #ddd;
}

.form-control.border-bottom-only.is-invalid {
    border-bottom-color: var(--ito-red);
}
.form-control.border-bottom-only.is-invalid + label {
    color: rgba(204,7,30,.4);
}

.form-floating>label {
    padding-left: 0;
    transition: * 0.1s ease-in-out;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-select ~ label {
    padding-left: .75rem;
    font-size: .8rem;
}
.form-control.border-bottom-only:focus {
    box-shadow: none;
    border: 1px solid #ddd
}
#map {width: 90%; margin: 0 auto; position: relative; height: 300px;}
@media(min-width: 768px) {
    #map {width: 60%; height: 400px; position: absolute;}
}
.mapcontent {height: 400px;}
#map .marker {
    width: 30px;
    height: 30px;
    cursor: pointer;
    background: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="rgb(204,7,30)" class="bi bi-geo" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999zm2.493 8.574a.5.5 0 0 1-.411.575c-.712.118-1.28.295-1.655.493a1.319 1.319 0 0 0-.37.265.301.301 0 0 0-.057.09V14l.002.008a.147.147 0 0 0 .016.033.617.617 0 0 0 .145.15c.165.13.435.27.813.395.751.25 1.82.414 3.024.414s2.273-.163 3.024-.414c.378-.126.648-.265.813-.395a.619.619 0 0 0 .146-.15.148.148 0 0 0 .015-.033L12 14v-.004a.301.301 0 0 0-.057-.09 1.318 1.318 0 0 0-.37-.264c-.376-.198-.943-.375-1.655-.493a.5.5 0 1 1 .164-.986c.77.127 1.452.328 1.957.594C12.5 13 13 13.4 13 14c0 .426-.26.752-.544.977-.29.228-.68.413-1.116.558-.878.293-2.059.465-3.34.465-1.281 0-2.462-.172-3.34-.465-.436-.145-.826-.33-1.116-.558C3.26 14.752 3 14.426 3 14c0-.599.5-1 .961-1.243.505-.266 1.187-.467 1.957-.594a.5.5 0 0 1 .575.411z"/></svg>');
    background-position: center center;
    background-repeat: no-repeat;
  }
/* TRANSITIONS */
.slide-fade-enter {
  transform: translateX(0px);
  opacity: 0;
}
.slide-fade-enter-active,
.slide-fade-enter-leave {
  transition: all 1000ms;
}
.slide-fade-leave-to {
  opacity: 0;
  transform: translateX(0px);
}
.d-content a {color: var(--ito-red); text-decoration: none;}
.d-content a:hover {text-decoration: underline;}

.d-content a h3 {margin: 2rem 0 1rem 0 !important}

.bg-grey {background: #ddd; background: linear-gradient(0deg, rgba(0,0,0,.05)70%, rgba(0,0,0,0) 100%);}
</style>
